// extracted by mini-css-extract-plugin
export default {"wrapper":"inputWithArrows_wrapper__e6S0q","arrow":"inputWithArrows_arrow__Zub6w"};